
import { makeACall } from "@/service/utils/useful"
import { defineComponent, computed } from "vue"
import { useStore } from "vuex"
import { AutocallNumber } from "@/service/constant.json"

export default defineComponent({
  setup() {
    const { state, commit, dispatch } = useStore()
    const warningMessage = computed(() => state.warning.warningMessage)

    const setIsWarning = () => dispatch("warning/closeWarning")
    const setIsDialogOpen = (value: boolean) => commit("complete/SET_ISDIALOG_OPEN", value)

    return {
      warningMessage,
      setIsWarning,
      setIsDialogOpen,
      makeACall,
      AutocallNumber,
    }
  },
})
